import React from 'react'
import { Box } from '@workwhile/ui'
import { InvoiceIssuesHeader } from './InvoiceIssuesHeader'
import { MissingDepartmentSection } from './MissingDepartmentSection'
import { StaleUnfinalizedSection } from './StaleUnfinalizedSection'
import { MissedInvoiceSection } from './MissedInvoiceSection'

export const InvoiceIssuesMain = () => {
  return (
    <>
      <InvoiceIssuesHeader />
      <Box margin={3}>
        <MissingDepartmentSection />
        <StaleUnfinalizedSection />
        <MissedInvoiceSection />
      </Box>
    </>
  )
}
